import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Partneransokan = lazy(() => import("@/pages/info/Partneransokan"));

export const Route = createFileRoute("/partneransokan")({
  component: () => <Partneransokan />,
});
